import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ShipmentFilter from './shipment-filter';
import ShipmentTable from './shipment-table';
import ShipmentTile from './shipment-tile';
import ShipmentSearch from './shipment-search';
import { selectShipmentFilterVisible, selectTileView } from './store/selectors'; // Import the selector

const ShipmentContent = props => {
  const isFilterVisible = useSelector(selectShipmentFilterVisible); // Use the selector
  const showTileView = useSelector(selectTileView); // Use the selector

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <ShipmentSearch />
        </div>
        {isFilterVisible && <ShipmentFilter />}

        {!showTileView ? <ShipmentTable /> : <ShipmentTile />}
      </div>
    </div>
  );
};

export default ShipmentContent;
